import type { ErrorComponentProps } from "@tanstack/react-router";
import { ApiError } from "@softmax/observatory-client/transport";
import { ProductRouteError } from "@/session/product-route-frame";
import { GameRedirect } from "./game-redirect";
import { useGameRoute } from "./use-game-route";

export function GameRouteError(props: ErrorComponentProps) {
  const { href } = useGameRoute();

  if (props.error instanceof ApiError && props.error.status === 401)
    return <GameRedirect sourceHref={href} navigation={{ kind: "sign-in" }} />;

  return <ProductRouteError {...props} />;
}
